import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import styles from './index.module.scss';
import MaturityMethods from '../../../../../../../constants/maturityMethods';
import dayjs from 'dayjs';
import Mixture from '../../../../../../../models/thermalControl/Mixture';

const { parameters, parametersHeader, parameter } = styles;

const MixtureData = ({ mixture, isManual }) => {
  const intl = useIntl();

  return (
    <>
      <div className={parameters}>
        <div className={parametersHeader}>
          {!isManual && <div>{intl.formatMessage({ id: 'ts' })}</div>}
          <div style={{ whiteSpace: 'pre' }}>
            {intl.formatMessage({
              id: `strength.thermalcontrol.mixtures.create.params.${
                mixture.maturity_method === MaturityMethods.ARRHENIUS
                  ? 'equivalentAge'
                  : 'maturity'
              }`,
            })}{' '}
            {mixture.maturity_method === MaturityMethods.ARRHENIUS ? (
              <span style={{ textTransform: 'none' }}>{`${intl.formatMessage({
                id: 'days',
              })}`}</span>
            ) : (
              'ºC-h'
            )}
          </div>
          <div style={{ whiteSpace: 'pre' }}>
            {intl.formatMessage({ id: 'resistance' })}
            <span> MPa</span>
          </div>
        </div>
        {mixture.parameters.map((param, index) => (
          <div className={parameter} key={param.datetime ?? index}>
            {!isManual && (
              <div>{dayjs(param.datetime).format('DD/MM/YYYY HH:mm')}</div>
            )}
            <div>{parseFloat(param.maturity.toFixed(4))}</div>
            <div>{parseFloat(param.resistance.toFixed(4))}</div>
          </div>
        ))}
      </div>
    </>
  );
};

MixtureData.propTypes = {
  mixture: PropTypes.instanceOf(Mixture).isRequired,
  isManual: PropTypes.bool,
};

MixtureData.defaultProps = {
  isManual: false,
};

export default MixtureData;
